<div appPreventScroll class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
    <div class="bg-white rounded-xl w-full max-w-[400px] overflow-hidden transform transition-all flex flex-col items-center text-center"
        (click)="$event.stopPropagation()">

        <!-- Header / Icon -->
        <div
            class="px-4 py-6 sm:p-6 lg:p-8 flex flex-col gap-4 items-center overflow-y-auto custom-scroll sm:max-h-[calc(100vh-200px)]">
            <div class="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 19.5h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                </svg>
            </div>

            <h3 class="text-lg sm:text-xl lg:text-2xl font-semibold text-black leading-snug">
                Confirm Logout
            </h3>
            <p class="text-sm lg:text-base font-normal text-black/70 leading-5">
                Are you sure you want to logout? You will need to sign in again to access your account.
            </p>
        </div>

        <!-- Footer / Actions -->
        <div class="px-4 py-5 sm:p-5 lg:px-8 lg:pb-8 flex gap-4 w-full justify-center">
            <button type="button" (click)="closeModal()" [disabled]="isLoggingOut()"
                class="rounded-lg border border-[var(--color-gray-1)] text-sm xl:text-base font-medium text-black bg-[var(--color-gray-3)] hover:bg-[var(--color-gray-7)] transition duration-300 ease-in-out p-2.5 sm:py-3 sm:px-6 cursor-pointer flex-1 disabled:opacity-50 disabled:cursor-not-allowed">
                Cancel
            </button>
            <button type="button" (click)="confirmLogout()" [disabled]="isLoggingOut()"
                class="rounded-lg bg-orange-600 text-sm xl:text-base font-semibold text-white hover:bg-orange-700 transition duration-300 ease-in-out p-2.5 sm:py-3 sm:px-6 cursor-pointer flex-1 flex justify-center items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed border border-transparent">
                @if(isLoggingOut()) {
                <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                    </circle>
                    <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                </svg>
                } @else {
                Logout
                }
            </button>
        </div>
    </div>
</div>